import { Checkbox, FormControlLabel, Stack, Typography } from "@mui/material";
import React, { Dispatch, SetStateAction, SyntheticEvent } from "react";
import { ValidationTypes } from "types/validation";
import { validationSeverityFilterKey } from "./ValidationModal.component";
import { validationTypeToIcon } from "components/Validator/ValidationMessages.component";

interface ValidationFilterCheckboxProps {
  filterType: ValidationTypes;
  label: string;
  validationFilters: Record<ValidationTypes, boolean>;
  setValidationFilters: Dispatch<
    SetStateAction<Record<ValidationTypes, boolean>>
  >;
}

export default function ValidationFilterCheckbox({
  filterType,
  label,
  validationFilters,
  setValidationFilters,
}: ValidationFilterCheckboxProps) {
  const handleChange = (
    event: SyntheticEvent<Element, Event>,
    checked: boolean
  ) => {
    const updatedValidationFilters = {
      ...validationFilters,
      [filterType]: checked,
    };

    setValidationFilters(updatedValidationFilters);
    localStorage.setItem(
      validationSeverityFilterKey,
      JSON.stringify(updatedValidationFilters)
    );
  };

  return (
    <FormControlLabel
      control={<Checkbox defaultChecked={validationFilters[filterType]} />}
      onChange={handleChange}
      label={
        <Stack direction="row" alignItems="center" spacing={0.75}>
          <Typography>{label}</Typography>
          {validationTypeToIcon(filterType)}
        </Stack>
      }
    />
  );
}
